import { useRef, useEffect } from "react";

const VIDEOS = [
  { src: "/videos/v1.mp4", label: "Calacatta — Final Polish" },
  { src: "/videos/v2.mp4", label: "White Marble — Machine Polish" },
  { src: "/videos/v3.mp4", label: "Black Marble — Slurry Polish" },
  { src: "/videos/v4.mp4", label: "Nero — Mirror Finish" },
];

function VideoCard({ src, label }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.play().catch(() => {});
        } else {
          el.pause();
        }
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="flex flex-col gap-2">
      <div className="relative overflow-hidden aspect-[4/5] bg-stone-900">
        <video
          ref={ref}
          src={src}
          muted
          loop
          playsInline
          preload="metadata"
          className="w-full h-full object-cover"
        />
      </div>
      <p className="text-[11px] tracking-[0.2em] uppercase text-stone-500 text-center">{label}</p>
    </div>
  );
}

export default function VideoGallery() {
  return (
    <section className="py-16 md:py-20" style={{ backgroundColor: "#e8e2d8" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-10 reveal">
          <p className="text-[11px] tracking-[0.3em] uppercase text-stone-500 mb-3">The Process</p>
          <h2 className="font-serif text-3xl md:text-4xl text-stone-900">
            Craftsmanship in Motion
          </h2>
          <p className="mt-4 text-stone-600 max-w-xl">
            Every restoration is performed by hand — diamond tooling, wet polishing, and meticulous finishing that transforms worn stone into a mirror surface.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 reveal">
          {VIDEOS.map((v) => (
            <VideoCard key={v.src} src={v.src} label={v.label} />
          ))}
        </div>
      </div>
    </section>
  );
}
